import React from 'react'

import { JumpLink, JumpLinksContainer } from './styles'

interface JumpLinksProps {
  currentActiveLink: string
  links: {
    target: string
    text: string
  }[]
}

const JumpLinks = (props: JumpLinksProps) => {
  const { links, currentActiveLink } = props

  return (
    <JumpLinksContainer>
      {links.map((link: any, i: number) => (
        <React.Fragment key={`jumpLink${i}`}>
          {link.target && link.text ? (
            <JumpLink>
              <a href={`#${link.target}`}>
                <svg
                  className={`indicatorDot ${
                    currentActiveLink === link.target ? ' active' : ''
                  }`}
                  viewBox="0 0 100 100"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="50" cy="50" r="50" />
                </svg>
                {link.text}
              </a>
            </JumpLink>
          ) : null}
        </React.Fragment>
      ))}
    </JumpLinksContainer>
  )
}

export default JumpLinks
